import { Component, inject } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { ButtonPrimaryComponent } from '../../../shared/components/button-primary/button-primary.component';
import { UserService } from '../../../core/services/user.service';

@Component({
  selector: 'app-landing-header',
  standalone: true,
  imports: [SvgIconComponent, ButtonPrimaryComponent],
  templateUrl: './landing-header.component.html',
  styles: ``
})
export class LandingHeaderComponent {
  public userService = inject(UserService);
}
